import { TableColumn } from '../../../components/DataTable/TableColumn';
import { TextColumn } from '../../../components/DataTable/TextColumn';
import { DateColumn } from '../../../components/DataTable/DateColumn';
import { TrendyolOrder } from '../../../interfaces/Trendyol/TrendyolOrder';
import { TrendyolStatusCell } from './TrendyolStatusCell';
import { TrendyolProductsCell } from './TrendyolProductsCell';
import { Pagination } from '../../../interfaces/Pagination';
import { DataTable } from '../../../components/DataTable/DataTable';
import { PriceColumn } from '../../../components/DataTable/PriceColumn';
import { TrendyolOrderStatus } from '../../../interfaces/Trendyol/TrendyolOrderStatus';
import { sharedColors } from '../../../utils/Style';
import { TrendyolActionCell } from './TrendyolActionCell';

const rowColorizer = (order: TrendyolOrder) => {
  if (order.status === TrendyolOrderStatus.CANCELLED)
    return sharedColors.statusRedLightest;

  return order.shipmentImages.length > 0
    ? sharedColors.statusGreenLightest
    : sharedColors.blue1;
};

const columns: TableColumn<TrendyolOrder>[] = [
  {
    id: 'trendyol-id',
    name: 'Trendyol Paket No',
    accessor: (row) => <TextColumn value={row.trendyolID.toString()} />,
  },
  {
    id: 'customer-full-name',
    name: 'Müşteri Adı',
    accessor: (row) => <TextColumn value={row.customerFullName} />,
  },
  {
    id: 'products',
    name: 'Ürünler',
    accessor: (row) => <TrendyolProductsCell order={row} />,
  },
  {
    id: 'status',
    name: 'Durum',
    align: 'center',
    accessor: (row) => <TrendyolStatusCell order={row} />,
  },
  {
    id: 'total',
    name: 'Tutar',
    accessor: (row) => <PriceColumn value={row.total} />,
  },
  {
    id: 'created-at',
    name: 'Sipariş Tarihi',
    accessor: (row) => <DateColumn value={row.createdAt} />,
  },
  {
    id: 'actions',
    name: 'Aksiyon',
    accessor: (row) => <TrendyolActionCell order={row} />,
  },
];

type TrendyolOrdersTableProps = {
  orders: TrendyolOrder[];
  totalCount: number;
  pagination: Pagination;
  onPagination: (newPagination: Pagination) => void;
};

export const TrendyolOrdersTable = (props: TrendyolOrdersTableProps) => {
  return (
    <DataTable
      columns={columns}
      totalCount={props.totalCount}
      rows={props.orders}
      limit={props.pagination.pageSize}
      setLimit={(newLimit) =>
        props.onPagination({ page: 0, pageSize: newLimit })
      }
      page={props.pagination.page}
      setPage={(newPage) =>
        props.onPagination({ ...props.pagination, page: newPage })
      }
      rowColorizer={rowColorizer}
    />
  );
};
